// extracted by mini-css-extract-plugin
module.exports = {"desNav":"DesNav_desNav__3e0Co","dropMenu":"DesNav_dropMenu__uBRYa"};